export class AlertHelper {
  static setDropDown(dropDown) {
    this.dropDown = dropDown;
  }

  static show(type, title, message, interval) {
    if (this.dropDown) {
      this.dropDown.alertWithType(type, title, message, null, interval || 2000);
    }
  }

  static setOnClose(onClose) {
    this.onClose = onClose;
  }

  static invokeOnClose() {
    if (typeof this.onClose === 'function') {
      this.onClose();
    }
  }
}
